import { useTranslation } from 'next-i18next'
import { Fragment } from 'react'

import PanelElementContainer from '~/panels/components/PanelElementContainer'
import SessionItem from '~/components/Session/Session'
import { Session } from '~/types/tutoring-api'

export default function PanelNextSession({ nextSession }: { nextSession: Session | undefined }): React.ReactElement {
  const { t } = useTranslation('studentPanel')

  if (!nextSession) {
    return <Fragment />
  }

  return (
    <PanelElementContainer header={t('nextAppointment')}>
      <SessionItem forceExpanded session={nextSession} sessionTutor={nextSession.sessionMentor} withWrapper={false} />
    </PanelElementContainer>
  )
}
